module.exports = __webpack_public_path__ + "static/media/christmas_icon.1cb6394b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/christmas_icon.png
// module id = 1049
// module chunks = 0